/**
 * encode form parameter string from object
 * @param {Object} obj target object
 */
export function encodeFormParams(obj: { [key: string]: any }) {
  return Object.keys(obj)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
    .join('&')
}

/**
 * encode url parameter string from object
 * replace null value to ''
 * @param {Object} obj target object
 */
export function encodeUrlParams(urlParams: { [key: string]: any }) {
  return Object.keys(urlParams)
    .filter((key: string) => {
      // ignore empty
      return !!urlParams[key]
    })
    .map(key => `${key}=${encodeURIComponent(urlParams[key] || '')}`)
    .join('&')
}
